import * as C from './constants'

export const hydrateUniteFailure = () => ({
  type: C.HYDRATE_UNITE_FAILURE,
})

export const authError = (error) => ({ type: C.ERROR, payload: error })

export const updateToken = (token) => ({
  type: C.TOKEN_UPDATE,
  payload: token,
})
